import { Autocomplete, Chip, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { IStandardMultipleAutocomplete } from '../../_common/interface/autocomplete/iStandardMultipleAutocomplete';
import { IDropdownData } from '../../_common/interface/dropdown/iDropdownData.interface';

interface IMultipleExtAutocomplete extends IStandardMultipleAutocomplete {
    itemsLoader: (parentId?: number) => Promise<any>,
    label: string
}


export const MultipleAutoComplete = (params: IMultipleExtAutocomplete) => {

    const [isLoading, setLoading] = useState(false);
    const [items, setItems] = useState<Array<IDropdownData>>([]);

    useEffect(() => {
        if (params.hasParent === true) {
            if (params.parentId ? params.parentId > 0 : null) {
                fetchItems(params.parentId);
            }
            else if (items?.length > 0) {
                setItems([]);
            }
        }
        else {
            fetchItems();
        }
    }, [params.parentId]);

    useEffect(() => {
        // params.onItemChange?.({ target: { name: params.name, value: _items } }, _items, params.name);
        if (items && params.items && items.length && params.items.length && params.items[0].name === undefined) {
            var _items = items.filter((m: any) => {
                if (params.items && params.items.length) {
                    var itemIds = params.items.map((i: any) => i.id);
                    return itemIds.includes(m.id);
                }
            });
            params.onItemChange?.({ target: { name: params.name, value: _items } }, _items, params.name);
        }
    }, [params.items, items]);

    function fetchItems(parentId?: number) {
        setLoading(true);
        return params.itemsLoader(parentId)
            .then(
                (json) => {
                    if (!json || json.length < 1) {
                        setItems([]);
                    }
                    else {

                        // var _items = json.filter((m: any) => {
                        //     if (params.items && params.items.length) {
                        //         var itemIds = params.items.map((i: any) => i.id);
                        //         return itemIds.includes(m.id);
                        //     }
                        // });

                        // params.onItemChange?.({ target: { name: params.name, value: [{ id: 33, name: "Clubman" }] } }, [{ id: 33, name: "Clubman" }], params.name);
                        setItems(json);
                    }
                },
                (err) => {
                    setItems([]);
                }
            )
            .finally(() => setLoading(false));
    }


    return (
        params.isHiddenIfEmpty && (!items || items.length == 0) ?
            null :
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={params.items && params.items.length ? items.filter(m => !params.items?.some(r => r.id == m.id)) : items}
                value={params.items || []}
                // defaultValue={params.items}
                disableCloseOnSelect
                filterSelectedOptions
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name}
                groupBy={(option) => params.groupedBy ? option[params.groupedBy] : null}
                onChange={(e, v) => { params.onItemChange?.({ target: { name: params.name, value: v } }, v, params.name); }}
                renderTags={(value, getTagProps) => {
                    return value.map((option, index: number) => (
                        <Chip
                            label={option.name}
                            {...getTagProps({ index })}
                        />
                    ))
                }
                }
                renderInput={(props) =>
                (<TextField {...props}
                    variant={params.variant || "filled"}
                    label={params.label}
                    required={params.isRequired}
                    placeholder="Search... &#x1F50D; "
                    fullWidth
                />)}
            />
    );
}